import { render, staticRenderFns } from "./SmartUserOrder.vue?vue&type=template&id=2c2e2fe9&"
import script from "./SmartUserOrder.vue?vue&type=script&lang=js&"
export * from "./SmartUserOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports